import React from 'react';
import {optionId} from "../../utils/utils";
import {Field} from 'redux-form';

const SelectField = ({name, options, disabled=false
        }) => {

    return <>
        <Field disabled={disabled} className="sm" name={name} component="select">
            {options.map(
                (option, index) => (
                    <option key={index} value={option.value.toString()}>{option.label || option}</option>
                )
            )}
        </Field>
    </>
};

export default SelectField;